module.exports = __webpack_public_path__ + "static/img/lp-2.f0a8811.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/index/lp-2.png
// module id = dQUH
// module chunks = 0